import { utils } from '@/helpers';

export type CampaignTabType = 'campaigns' | 'sponsoring' | 'installed' | 'sponsored';

export const CampaignTabs = {
	campaigns: {
		label: () => 'My Campaigns',
		isVisible: () => true,
		shouldShowContent: (currentTab: CampaignTabType) => {
			return currentTab === 'campaigns';
		},
	},

	// IF viewing as a "brand" the "coMarketing" tab will show all campaigns they are sponsoring
	// IF they are viewing as a "retailer" the "My Co-Marketing" tab will show installed templates
	sponsoring: {
		label: () => 'My Co-Marketing',
		isVisible: () => utils.isBrand(),
	},
	// If viewing as a "vertical" the "installed" tab will show installed templates
	installed: {
		label: () => (utils.isVertical() ? 'Installed Templates' : 'My Co-Marketing'),
		isVisible: () => utils.isRetail(),
	},
	// If viewing as a "retailer" the "sponsored" tab will show sponsored campaigns
	sponsored: {
		label: () => 'Sponsored Campaigns',
		isVisible: () => utils.isRetail(),
	},
} as const;
